import * as React from 'react';
import {
  MessageBar,
  MessageBarBody,
  FluentProvider,
  webLightTheme,
} from '@fluentui/react-components';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';

interface IMultiLineErrorMessage {
  message: string;
  isMultiline?: boolean;
  showError: boolean | unknown;
  type: 'error' | 'warning';
  wrapInFluentProvider?: boolean;
}
const MultiLineErrorMessage = (props: IMultiLineErrorMessage): JSX.Element => {
  const { showError, message, isMultiline, type, wrapInFluentProvider = true } = props;

  const messageBar = (
    <MessageBar intent={type} layout={isMultiline ? 'multiline' : undefined}>
      <MessageBarBody>
        <Stack>
          <span>{message}</span>
        </Stack>
      </MessageBarBody>
    </MessageBar>
  );

  return (
    <>
      {showError &&
        (wrapInFluentProvider ? (
          <FluentProvider theme={webLightTheme}>{messageBar}</FluentProvider>
        ) : (
          messageBar
        ))}
    </>
  );
};

export default MultiLineErrorMessage;
